import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "fs-2 fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "fw-semobold fs-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.widgetClasses)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", {
        class: _normalizeClass([_ctx.icon, "fs-1 me-2"])
      }, null, 2),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    (_ctx.subTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.subTitle), 1))
      : _createCommentVNode("", true)
  ], 2))
}